
/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
 
      var FeaturedIcons = new Swiper(".FeaturedIcons", {
        slidesPerView: 1,
        spaceBetween: 10,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          640: {
            slidesPerView: 2
          },
          1024: {
            slidesPerView: 3
          },
          1200: {
            slidesPerView: 4
          },
        },
      });
    const ProductSlider = new Swiper('.ProductList-slider', {

      slidesPerView: "auto",
      loop: false,
      freeMode: false,
      spaceBetween: 0,
      slideToClickedSlide: false,
      grabCursor: false,
            navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
          640: {
            slidesPerView: 2,
              spaceBetween: 30,
              loop: false
          },
          1024: {
            slidesPerView: 3,
              spaceBetween: 30,
              loop: false
          },
          1380: {
            slidesPerView: 4,
              spaceBetween: 30,
                loop: false
          },
        }
    });
      var ReviewsList = new Swiper(".ReviewsList", {
        slidesPerView: 1,
        spaceBetween: 10,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
              spaceBetween: 20
          },
          1024: {
            slidesPerView: 2,
              spaceBetween: 30
          },
          1200: {
            slidesPerView: 3,
              spaceBetween: 40
          },
        },
      });   
      
      /**
* Timer
*/

var d = 1;
var h = 23;
var m = 59;
var s = 00;

(function( $ ) {

  $.fn.timer = function(params) {
    var html = "<div class='_time days'><h3>" +  "</h3><label>Days</label></div>";
    html += "<div class='_time hours'><h3>" + "</h3><label>Hours</label></div>";
    html += "<div class='_time minutes'><h3>" + "</h3><label>Mins</label></div>";
    html += "<div class='_time seconds'><h3>" + "</h3><label>Secs</label></div>";
    this.html(html);
    var ths = this;

    rem_time = get_formated_ramainin_time(d, h, m, s);
    var days = rem_time.days;
    var hours = rem_time.hours;
    var minutes = rem_time.minutes;
    var seconds = rem_time.seconds;


    setInterval(function(){
      if(seconds <= 0 && (minutes > 0 || hours > 0 || days > 0) ) {
        seconds = 59;
        minutes = minutes - 1;
      } else {
        seconds--;
      }

      if(minutes <0 && (hours > 0 || days > 0)) {
        minutes = 59;
        hours = hours - 1;
      }

      if(hours < 0 && days > 0) {
        hours = 23;
        days = days - 1;
      }
      if(hours < 4 ) {
        hours = 23;
      }


      ths.find('.days h3').text(twoDigit(days));
      ths.find('.hours h3').text(twoDigit(hours));
      ths.find('.minutes h3').text(twoDigit(minutes));
      ths.find('.seconds h3').text(twoDigit(seconds));


    }, 1000);

  };

}( jQuery ));

   
function twoDigit(number) {
  var twodigit = number >= 10 ? number : "0"+number.toString();
  return twodigit;
}

function get_formated_ramainin_time(d, h, m, s){
  var current_date = calcTime(-5);//new Date();

  current_date.setHours(h);
  current_date.setMinutes(m);
  current_date.setSeconds(s);
  if((calcTime(-5)).getTime() > current_date) {
    current_date.setDate(current_date.getDate()+d);
  }
  //alert(current_date);
  var diff = (current_date - calcTime(-5));
  var secDiff = diff / 1000; //in s
  var minDiff = diff / 60 / 1000; //in minutes
  var hDiff = diff / 3600 / 1000; //in hours
  var daysDiff = Math.floor(hDiff / 24);

  var humanReadable = {};
  humanReadable.days = daysDiff;
  humanReadable.hours = Math.floor(hDiff) - daysDiff;
  humanReadable.minutes = Math.floor(minDiff - (60 * Math.floor(hDiff)));
  humanReadable.seconds = 0;

  return humanReadable;
}

function calcTime(offset) {



  // create Date object for current location
  d = new Date();
  // convert to msec
  // add local time zone offset
  // get UTC time in msec
  utc = d.getTime() + (d.getTimezoneOffset() * 60000);
  // create new Date object for different city
  // using supplied offset
  nd = new Date(utc + (3600000*offset));

  return nd;

}

$(document).ready(function() {
  var usDay = new Date('2022-11-27 23:59:00');

  
// $('#timer').countdown({until: usDay, timezone: -8});
  $('#timer').countdown({until: +41400});
   var d = new Date();
  // if(usDay > d){
  //   $('.timer_progress').show();
  // }else{
  //    $('.timer_progress').hide();
  // }
  $('.Sticky__AddToCart').on('click', function(){
  $('[data-action="add-to-cart"]').trigger('click');
  });
  
  var distance = $('[data-action="add-to-cart"]').offset().top - 100,
      
    $window = $(window);
$window.scroll(function() {
      //fix for smile rewards impl. 19/01/26 mike.
    if ( $window.scrollTop() >= distance ) {
      $('.product-sticky-container').addClass('active');
      $('#smile-ui-lite-container').hide();
    }else{
    $('.product-sticky-container').removeClass('active'); $('#smile-ui-lite-container').show();
    }
});
});

    $("a.reviewStar").on('click', function(event) {

      // Make sure this.hash has a value before overriding default behavior
      if (this.hash !== "") {
        // Prevent default anchor click behavior
        event.preventDefault();

        // Store hash
        var hash = this.hash;

        // Using jQuery's animate() method to add smooth page scroll
        // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
        $('html, body').animate({
          scrollTop: $(hash).offset().top -250
        }, 800, function(){

          // Add hash (#) to URL when done scrolling (default click behavior)
          //window.location.hash = hash;
        });
      } // End if
    });
var $darkbox = $("<div/>",{id:"darkbox"}).on("click", function(){
	$(this).removeClass("on");
}).appendTo("body");
$('img[data-darkbox]').css({cursor:"pointer"}).on("click",function(){
	var o=this.getBoundingClientRect();
	$darkbox.css({
		transition:"0s",
		backgroundImage:"url("+this.src+")",
		left:o.left, top:o.top,
		height:this.height, width:this.width
	});
	setTimeout(function(){
		$darkbox.css({transition:".4s"}).addClass("on"); 
	},1);
});
